/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editTraineesActions, {
    editTraineesTypes,
} from '../../../redux/collectData/editTraineesBySector'
import getTraineesBySectorActions from '../../../redux/collectData/getTraineesBySector'
import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editTraineesSagas({ response }) {
    try {
        const res = yield Put(
            `collect_data/graduate_training/${response.id}`,
            response
        )
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getTraineesBySectorActions.getTraineesBySectorRequest()
                ),
                yield put(editTraineesActions.editTraineesSuccess(res.data)),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(editTraineesActions.editTraineesFailure(res))
        }
    } catch (error) {
        yield put(editTraineesActions.editTraineesFailure(error))
    }
}

export function* editTraineesSaga() {
    yield takeLatest(editTraineesTypes.EDIT_TRAINEES_REQUEST, editTraineesSagas)
}
